export const SourceTypes = {
    panel: 'panel',
    label: 'label',
    button: 'button',
    list: 'list',
    line: 'line',
    tabs: 'tabs',
    field: 'field',
    fieldArray: 'fieldArray',
    image: 'image',
    card: 'card',
    chat: 'chat',
    text: 'text',
    survey: 'survey',
    entity: 'entity',
    embeddedScreen: 'embeddedScreen',
    stepper: 'stepper',
    progress: 'progress',
    selectionCriteria: 'selectionCriteria',
    context: 'context',
    feed: 'feed',
    feedPost: 'feedPost',
    forEach: 'forEach',
    actionsBar: 'actionsBar',
    bottomMenu: 'bottomMenu',
    maps: 'maps',
    marker: 'marker',
    circle: 'circle',
    checkbox: 'checkbox',
    dropzone: 'dropzone',
    icon: 'icon',
    searchBar: 'searchBar',
    frame: 'frame',
    header: 'header',
    sidebar: 'sidebar',
    menu: 'menu',
    badge: 'badge',
    interval: 'interval',
    rating: 'rating',
    radioGroup: 'radioGroup',
    band: 'band',
    block: 'block',
    swiper: 'swiper',
    swiperItem: 'swiperItem',
    footer: 'footer',
    accordion: 'accordion',
    options: 'options',
    fullView: 'fullView',
    calendar: 'calendar',
    serverTime: 'serverTime',
    webSocket: 'webSocket',
    dataSource: 'dataSource',
    camera: 'camera',
    pdfReader: 'pdfReader',
    pageBreak: 'pageBreak',
    shortcut: 'shortcut',
    restrictions: 'restrictions',
    switch: 'switch',
    table: 'table',
    tree: 'tree'
};

export const AcceptTypes = {
    listToolBar: [
        'button', 'progress', 'label', 'badge', 'image', 'options', 'serverTime',
        'block', 'forEach', 'rating', 'switch', 'checkbox', 'field'
    ],
    maps: ['marker', 'circle'],
    badge: ['button', 'card', 'label', 'image', 'icon'],
    screenBar: [
        'panel', 'entity', 'label', 'button', 'context',
        'list', 'card', 'field', 'fieldArray', 'text',
        'line', 'tabs', 'image', 'card', 'chat', 'text',
        'survey', 'embeddedScreen', 'stepper', 'progress',
        'selectionCriteria', 'feed', 'feedPost', 'forEach',
        'actionsBar', 'bottomMenu', 'maps', 'checkbox', 'dropzone',
        'icon', 'searchBar', 'header', 'footer', 'frame', 'sidebar', 'badge',
        'interval', 'rating', 'radioGroup', 'band', 'block', 'swiper',
        'accordion', 'options', 'fullView', 'calendar', 'serverTime', 'webSocket',
        'dataSource', 'camera', 'pdfReader', 'pageBreak', 'shortcut', 'restrictions',
        'table', 'tree'
    ],
    panel: [
        'panel', 'label', 'button',
        'list', 'card', 'field', 'fieldArray', 'text',
        'line', 'tabs', 'image', 'card', 'chat', 'text',
        'survey', 'embeddedScreen', 'stepper', 'progress',
        'selectionCriteria', 'feed', 'feedPost', 'forEach',
        'maps', 'bottomMenu', 'checkbox', 'dropzone', 'icon', 'menu',
        'searchBar', 'badge', 'rating', 'radioGroup', 'band', 'block', "swiper",
        'accordion', 'options', 'fullView', 'calendar', 'serverTime', 'camera', 'pdfReader',
        'restrictions', 'table'
    ],
    column: [
        'panel', 'label', 'button', 'list', 'card',
        'text', 'line', 'tabs', 'field', 'fieldArray',
        'image', 'card', 'chat', 'text', 'survey',
        'embeddedScreen', 'stepper', 'progress',
        'selectionCriteria', 'feed', 'feedPost',
        'forEach', 'maps', 'bottomMenu', 'checkbox', 'dropzone', 'menu',
        'icon', 'searchBar', 'badge', 'rating', 'radioGroup', 'block', "swiper",
        'accordion', 'options', 'fullView', 'calendar', 'serverTime', 'camera', 'pdfReader',
        'restrictions', 'table'
    ],
    componentTarget: [
        'panel', 'label', 'button', 'list', 'card',
        'field', 'fieldArray', 'text', 'line', 'tabs',
        'image', 'card', 'chat', 'text', 'survey',
        'embeddedScreen', 'stepper', 'progress',
        'selectionCriteria', 'feed', 'feedPost', 'forEach',
        'maps', 'bottomMenu', 'checkbox', 'dropzone', 'icon', 'searchBar',
        'menu', 'badge', 'rating', 'radioGroup', 'block', "swiper",
        'accordion', 'options', 'fullView', 'calendar', 'serverTime', 'camera', 'pdfReader', 'pageBreak',
        'restrictions', 'switch', 'table', 'tree'
    ],
};
